import React from 'react';

import { VoucherFormValidSince } from './ValidSince';
import { VoucherFormValidUntil } from './ValidUntil';

const VoucherFormValidityInterval: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  return (
    <>
      <VoucherFormValidSince disabled={disabled} />
      <VoucherFormValidUntil disabled={disabled} />
    </>
  );
};

export default VoucherFormValidityInterval;
